import React, { useState, useEffect } from "react";
import { Form, Input, InputNumber, Button, Row, Col, notification } from "antd";
import {
  TagOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { updatePlaceApi } from "../../../../api/place";
import { getAccessToken } from "../../../../api/auth";

import "./EditPlaceForm.scss";

export default function EditPlaceForm(props) {
  const { place, setIsVisibleModal, setReloadPlaces } = props;
  const [placeData, setPlaceData] = useState({});

  //trae los datos de lugar
  useEffect(() => {
    setPlaceData({
      place_code: place.place_code,
      description: place.description,
    });
  }, [place]);

  //Verifica que no exista errores en los datos que se deben validar
  const isFormValid = (e) => {
    let errorExists = false;
    if (!placeData.description) {
      notification["error"]({
        message: "Obligatorio: descripción.",
      });
      errorExists = true;
    } else {
      errorExists = false;
    }
    return errorExists;
  };

  const updatePlace = (e) => {
    e.preventDefault();
    const error = isFormValid();
    if (!error) {
      const token = getAccessToken();
      let placeUpdate = placeData; //es let porque se va actualizando

      updatePlaceApi(token, placeUpdate, place._id).then((result) => {
        if (
          result.message === "ERR_CONNECTION_REFUSED" ||
          result.message === "Failed to fetch" ||
          result.message === undefined
        ) {
          notification["error"]({
            message: "Servidor caido",
          });
          setIsVisibleModal(true);
        } else if (result.code !== 200) {
          notification["error"]({
            message: result.message,
          });
          setIsVisibleModal(true);
        } else {
          notification["success"]({
            message: result.message, //el mensaje que viene del server
          });
          //console.log("respuesta: " + result.message);
          setIsVisibleModal(false);
          setReloadPlaces(true);
        }
      });
    }
  };

  return (
    <div className="edit-place-form">
      <EditForm
        placeData={placeData}
        setPlaceData={setPlaceData}
        updatePlace={updatePlace}
      />
    </div>
  );
}

function EditForm(props) {
  const { placeData, setPlaceData, updatePlace } = props;

  return (
    <Form className="form-edit" onSubmit={updatePlace}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={12}>
          <label className="control-label">Código</label>
          <Form.Item>
            <InputNumber
              prefix={<TagOutlined />}
              placeholder="Automático"
              value={placeData.place_code}
              onChange={(e) => setPlaceData({ ...placeData, place_code: e })}
              style={{ width: "100%" }}
              disabled={true}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <label className="control-label">
            <span className="control-required">* </span>Descripción
          </label>
          <Form.Item>
            <Input
              //   placeholder="descripción"
              value={placeData.description}
              onChange={(e) =>
                setPlaceData({ ...placeData, description: e.target.value })
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="btn-submit"
          onClick={updatePlace}
        >
          Actualizar
        </Button>
      </Form.Item>
    </Form>
  );
}
